import { api } from "../api";
import { avatarColor, resolveStatus } from "../cells";
import type { BoardSnapshot, Item } from "../types";

// Kanban groups items by the first status column (like Monday's status board).
export function KanbanView({ snap, reload }: { snap: BoardSnapshot; reload: () => void }) {
  const statusCol = snap.columns.find((c) => c.type === "status" && (c.settings.labels?.length ?? 0) > 0);
  const labels = statusCol?.settings.labels ?? [];

  const itemsFor = (labelId: string): Item[] =>
    snap.items.filter((it) => {
      const s = statusCol ? resolveStatus(it.cells[statusCol.id] ?? null, statusCol) : null;
      return s?.id === labelId;
    });

  async function move(it: Item, labelId: string) {
    if (!statusCol) return;
    await api.setCell(it.id, statusCol.id, { id: labelId });
    reload();
  }

  function onDrop(e: React.DragEvent, labelId: string) {
    e.preventDefault();
    const id = e.dataTransfer.getData("text/item");
    const it = snap.items.find((x) => x.id === id);
    if (it) move(it, labelId);
  }

  if (!statusCol) return <div className="board-scroll"><p className="muted">Keine Status-Spalte vorhanden.</p></div>;

  return (
    <div className="kanban">
      {labels.map((l) => {
        const cards = itemsFor(l.id);
        return (
          <div className="kan-col" key={l.id}>
            <div className="kan-col-head" style={{ background: l.color }}>{l.label} · {cards.length}</div>
            <div className="kan-cards" onDragOver={(e) => e.preventDefault()} onDrop={(e) => onDrop(e, l.id)}>
              {cards.map((it) => <Card key={it.id} item={it} snap={snap} />)}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function Card({ item, snap }: { item: Item; snap: BoardSnapshot }) {
  const prioCol = snap.columns.find((c) => c.title === "Priorität");
  const peopleCol = snap.columns.find((c) => c.type === "people");
  const prio = prioCol ? resolveStatus(item.cells[prioCol.id] ?? null, prioCol) : null;
  const peopleVal = peopleCol ? item.cells[peopleCol.id] : null;
  const names = peopleVal && typeof peopleVal === "object"
    ? ("users" in peopleVal ? peopleVal.users.map((u) => u.name)
      : "names" in peopleVal ? peopleVal.names : [])
    : [];

  return (
    <div className="kan-card" draggable
      onDragStart={(e) => e.dataTransfer.setData("text/item", item.id)}>
      <div className="nm">{item.name}</div>
      <div className="kan-tags">
        {prio && <span className="tag" style={{ background: prio.color }}>{prio.label}</span>}
      </div>
      <div className="people-stack" style={{ marginTop: 8 }}>
        {names.map((n, i) => (
          <span key={i} className="avatar" style={{ background: avatarColor(n) }} title={n}>
            {n.split(/\s+/).map((p) => p[0]).slice(0, 2).join("").toUpperCase()}
          </span>
        ))}
      </div>
    </div>
  );
}
